import { Breadcrumb, Flex, PageTemplate } from '@npco/zeller-design-system'

import { SitesList } from 'pages/Settings/Sites/SitesList/SitesList'
import { MobileNavHeader } from 'components/Sidebar/components/MobileNavHeader/MobileNavHeader'
import { page } from 'translations'

export const Sites = () => {
  return (
    <PageTemplate
      HeaderMobileRow={<MobileNavHeader />}
      HeaderPrimaryRow={
        <PageTemplate.HeaderPrimaryRow>
          <Flex height="48px">
            <Breadcrumb>
              <Breadcrumb.Item>
                <Breadcrumb.Text>{page.title.sites}</Breadcrumb.Text>
              </Breadcrumb.Item>
            </Breadcrumb>
          </Flex>
        </PageTemplate.HeaderPrimaryRow>
      }
    >
      <PageTemplate.Section>
        <SitesList />
      </PageTemplate.Section>
    </PageTemplate>
  )
}
